(() => {
  const STORAGE_KEY = 'otao-custom-collection-filters';

  const readState = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || { equipment: [], model: [] };
    } catch {
      return { equipment: [], model: [] };
    }
  };

  const writeState = (state) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {}
  };

  const getStateFromInputs = () => ({
    equipment: Array.from(document.querySelectorAll('input[data-custom-filter="equipment"]:checked')).map(
      (input) => input.value
    ),
    model: Array.from(document.querySelectorAll('input[data-custom-filter="model"]:checked')).map((input) => input.value),
  });

  const syncInputsFromState = (state) => {
    document.querySelectorAll('input[data-custom-filter]').forEach((input) => {
      const group = input.dataset.customFilter;
      input.checked = Boolean(state[group]?.includes(input.value));
    });
  };

  const applyFilters = () => {
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;

    const productItems = Array.from(productGrid.querySelectorAll('.grid__item[data-equipment]'));
    const emptyState = document.querySelector('[id^="CustomFilterEmpty-"]');
    const state = getStateFromInputs();

    writeState(state);

    let visibleCount = 0;

    productItems.forEach((item) => {
      const equipment = item.dataset.equipment || '';
      const models = (item.dataset.models || '').split(',').filter(Boolean);

      const matchesEquipment = state.equipment.length === 0 || state.equipment.includes(equipment);
      const matchesModel = state.model.length === 0 || state.model.some((model) => models.includes(model));
      const visible = matchesEquipment && matchesModel;

      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyState) {
      emptyState.classList.toggle('hidden', visibleCount !== 0);
    }
  };

  const syncAndApply = () => {
    syncInputsFromState(readState());
    applyFilters();
  };

  document.addEventListener(
    'input',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.matches('input[data-custom-filter]')) return;
      event.stopPropagation();
    },
    true
  );

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches('input[data-custom-filter]')) return;
    applyFilters();
  });

  document.addEventListener('DOMContentLoaded', syncAndApply);

  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    new MutationObserver(() => {
      syncAndApply();
    }).observe(productGridContainer, { childList: true, subtree: true });
  }
})();
